export default{
    "defalut":"遇到问题了?加群求助吧<br>官方QQ群：784885784 <br>你也可以扫码加入哦！",
    "202101":"遇到问题了?加群求助吧<br>官方QQ群：681698789 <br>你也可以扫码加入哦！",
    "202102":"遇到问题了?加群求助吧<br>官方QQ群：959798042 <br>你也可以扫码加入哦！",
    "202103":"遇到问题了?加群求助吧<br>官方QQ群：829226038 <br>你也可以扫码加入哦！",
    "202104":"遇到问题了?加群求助吧<br>官方QQ群：1016761749 <br>你也可以扫码加入哦！",
    "32201":"遇到问题了?加群求助吧<br>官方QQ群：912833238 <br>你也可以扫码加入哦！",
    "32202":"遇到问题了?加群求助吧<br>官方QQ群：912833238 <br>你也可以扫码加入哦！",
    "32203":"遇到问题了?加群求助吧<br>官方QQ群：912833238 <br>你也可以扫码加入哦！",
    "32211":"遇到问题了?加群求助吧<br>官方QQ群：912833238 <br>你也可以扫码加入哦！",
    "32212":"遇到问题了?加群求助吧<br>官方QQ群：912833238 <br>你也可以扫码加入哦！",
    "32213":"遇到问题了?加群求助吧<br>官方QQ群：912833238 <br>你也可以扫码加入哦！",
    "32000":"遇到问题了?加群求助吧<br>官方QQ群：885134961 <br>你也可以扫码加入哦！",
    "32301":"遇到问题了?加群求助吧<br>官方QQ群：885134961 <br>你也可以扫码加入哦！",
    "32302":"遇到问题了?加群求助吧<br>官方QQ群：885134961 <br>你也可以扫码加入哦！",
    "32303":"遇到问题了?加群求助吧<br>官方QQ群：885134961 <br>你也可以扫码加入哦！"
}


// WEBPACK FOOTER //
// ./src/manager/qq.js